/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechDeleteTranscriptionHistory } from "../../funcs/llmSpeechDeleteTranscriptionHistory.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteSpeechToTextHistoryRequest$inboundSchema,
};

export const tool$llmSpeechDeleteTranscriptionHistory: ToolDefinition<
  typeof args
> = {
  name: "llm-speech-delete-transcription-history",
  description: `Delete speech-to-text history item

Deletes a stored transcription. The audio blob is content-addressed and may be shared, so it is left in storage.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechDeleteTranscriptionHistory(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
